export const boxesNames = [
  {
    value: 'locker-small',
    label: 'small',
    icon: 'S'
  },
  {
    value: 'locker-medium',
    label: 'medium',
    icon: 'M'
  },
  {
    value: 'locker-large',
    label: 'large',
    icon: 'L'
  },
  {
    value: 'locker-semi-large',
    label: 'semi_large',
    icon: 'L'
  },
  {
    value: 'tiny',
    label: 'tiny',
    icon: 'T'
  }
];
